import { StyleSheet } from '@react-pdf/renderer';
import { theme } from 'v3/styles/global-styles';

export const styles = StyleSheet.create({
  body: {
    paddingTop: '0px',
    paddingBottom: '65px',
  },
  introText: {
    fontSize: 10,
    fontFamily: 'RookeryNew',
    fontWeight: 'bold',
    opacity: 0.5,
    color: theme.palette.common.black,
    paddingTop: '25px',
  },
  subIntroText: {
    fontSize: 8,
    fontFamily: 'RookeryNew',
    opacity: 0.5,
    color: theme.palette.common.black,
    paddingTop: '25px',
  },
  title: {
    fontSize: 15,
    fontFamily: 'RookeryNew',
    fontWeight: 'bold',
    paddingTop: '20px',
    paddingBottom: '10px',
    width: '50%',
    color: theme.palette.primary[100],
  },
  clientTitle: {
    fontSize: 10,
    fontFamily: 'RookeryNew',
    fontWeight: 'bold',
    width: '50%',
    color: theme.palette.common.black,
    opacity: 0.5,
  },
  clientSubtitle: {
    maxWidth: '100',
    fontSize: 10,
    color: theme.palette.common.black,
    opacity: 0.5,
    paddingTop: '7px',
    width: '160px',
  },
  financingTitle: {
    fontSize: 9,
    color: theme.palette.common.black,
    opacity: 0.5,
  },
  financingSubtitle: {
    opacity: 0.5,
    color: theme.palette.common.black,
    fontFamily: 'RookeryNew',
    fontWeight: 'bold',
  },
  financingLabel: {
    fontSize: 13,
    opacity: 0.5,
    color: theme.palette.common.black,
    fontFamily: 'RookeryNew',
    fontWeight: 'bold',
  },
  dataContainer: {
    color: theme.palette.secondary.main,
    padding: '10 0',
    fontSize: 10,
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
  },
  container: {
    paddingHorizontal: '50px',
    display: 'flex',
    minWidth: '100%',
  },
  rowClientData: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    minWidth: '95%',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    paddingHorizontal: '50px',
  },
  rowData: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    gap: 30,
  },
  rowFinancingData: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: '50px',
    paddingBottom: '10px'
  },
  dashContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    paddingHorizontal: '50px',
    paddingTop: '15px',
    paddingBottom: '30px',
  },
  dash: {
    width: 7,
    height: 1,
    backgroundColor: theme.palette.secondary.light,
  },
  image: {
    width: '80px',
    position: 'absolute',
    top: '10px',
    right: '40px',
  },
  header: {
    fontSize: 18,
    paddingLeft: '40px',
    fontFamily: 'RookeryNew',
    fontWeight: 'bold',
    display: 'flex',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary[100],
    height: '50px',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  footer: {
    fontSize: 10,
    paddingLeft: '50px',
    fontFamily: 'RookeryNew',
    fontWeight: 'bold',
    position: 'absolute',
    bottom: '40px',
    opacity: 0.5,
    color: theme.palette.common.black,
    paddingTop: '25px',
  },
});
